import { isNumber } from 'lodash';
import { INPUT_TYPES, DATE_FORMATS } from '../const';

export const getPrimaryKeyColName = (columns) => {
    const primaryKeyCol = columns.find((col) => {
        return col.isPrimaryKey;
    });
    return primaryKeyCol ? primaryKeyCol.name : '';
};

export const getDataValueObjectFromDto = (dataRow) => dataRow;

export const getDtoFromDataValueObject = (data, tableMetadata) => {
    const dataTypes = getDataTypesByInputType(tableMetadata.columns);

    for (const key in data) {
        const value = data[key];

        if (dataTypes[key] === INPUT_TYPES.CheckBox) {
            data[key] = value === true ? 1 : 0; // 1 is true, 0 is false
        }

        if (!value) {
            data[key] = null;
        }
    }

    return data;
};

export const getTableFormKey = (tableId) => `table${tableId}`;
export const getItemFormKey = (itemId) => `item${itemId}`;
export const getInputFormName = (tableId, itemId, columnName) =>
    `${getTableFormKey(tableId)}.${getItemFormKey(itemId)}.${columnName}`;

export const getTableIdFromInputName = (data) => Number(data.slice(5));
export const getItemIdFromInputName = (keys) => Number(keys.slice(4));

export const getInitialValueForColumnType = (row, column, tableMetadata) => {
    const dataTypes = getDataTypesByInputType(tableMetadata.columns);

    const isCheckboxWithValue = row[column] != null && dataTypes[column] === INPUT_TYPES.CheckBox;
    // Maps the field value to the correct value type that Formik expects as initial
    if (isCheckboxWithValue) {
        return row[column] === 1; // 1 is true, 0 is false
    }

    return row[column] || getDefaultValueForColumnType(dataTypes[column]);
};

export const getDefaultValueForColumnType = (columnType) => {
    // Chakra does .toString() for input values hence the empty strings
    switch (columnType) {
        case INPUT_TYPES.DropDownForm:
        case INPUT_TYPES.TextBox:
            return '';
        case INPUT_TYPES.ComboBox:
        case INPUT_TYPES.MonthCalendar:
        case INPUT_TYPES.CheckBox:
            return false;
        case INPUT_TYPES.NumericUpDown:
            return '';
        case INPUT_TYPES.ProgressBar:
            return '';
        default:
            return '';
    }
};

export const getDataTypesByInputType = (columns) =>
    columns.reduce((acc, col) => {
        acc[col.name] = col.inputTypeDescription;
        return acc;
    }, {});

export const parseColumnSettings = (settings) =>
    settings?.reduce((acc, setting) => {
        acc[setting.name] = setting.value;
        if (isNumber(setting.value)) {
            acc[setting.name] = parseFloat(setting.value);
        }
        return acc;
    }, {}) ?? {};

export const parseDateFormat = (column) => {
    return DATE_FORMATS[column.formatCode];
};

export const parseNumberFormat = (column) => {
    if (column.formatCode === 'Percentage') {
        return 'percent';
    }
    if (column.formatCode === 'c') {
        return 'currency';
    }
};
